import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Iframe from "react-iframe";
import { makeStyles } from "@material-ui/styles";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage,
  SimpleGallery
} from "../DocCreater";

import {
  startTestState,
  returnTestGrade,
  useTestState
} from "../../ilabx-grade-return";

const useStyles = makeStyles(theme => ({
  iframe: {
    width: "1282px",
    height: "822px",
    border: "solid 1px"
  }
}));
function VirtualPage(props) {
  const classes = useStyles();
  const matches_1280 = useMediaQuery("(min-width:1280px)");
  const matches_1800 = useMediaQuery("(min-width:1800px)");

  const { virtualUrl } = props;

  //ilabx update test state
  useTestState();
  //
  // returnTestGrade("测试实验", "60", "88");
  return (
    <>
      <Paragraph>
        <Text color="secondary">实验简介:</Text>
        本实验为清官式大木作虚拟搭建实验，包含平身科虚拟搭建与歇山大木虚拟搭建两个场景，详细操作指南与引导视频，请前往
        <DocLink to="/learn/step/4" newpage>
          虚拟搭建实验详细文档
        </DocLink>
        查看。
      </Paragraph>
      <Paragraph>
        <Text color="secondary">实验软件要求:</Text>
        推荐使用64位Google
        Chrome浏览器进行实验，如遇到实验无法显示请更换最新版浏览器，
        <DocLink to="https://www.google.cn/chrome/" newpage>
          下载Chrome浏览器
        </DocLink>
        。
      </Paragraph>
      <Paragraph>
        <Text color="secondary">实验全屏设置:</Text>
        为了获得最佳用户体验，请使用比例为16:9(例如1920*1080)的显示器，
        {/* <DocLink to={virtualUrl} newpage>
          新页面加载实验
        </DocLink> */}
        实验资源约120M，请耐心等待实验加载完毕后，再点击右下角全屏按钮进行实验。
      </Paragraph>
      <Paragraph>
        <Text color="secondary">快速操作提示:</Text>
        实验中使用鼠标右键旋转，按住滚轮平移，滑动滚轮缩放，左键选择构件，键盘QEWASD辅助移动选中构件，空格键切换构件方向，请务必配合键盘鼠标进行实验。
      </Paragraph>
      <div style={{ margin: "auto", width: "1282px" }}>
        {/* <Iframe
          url={virtualUrl}
          width={matches_1800 ? "1800px" : matches_1280 ? "1280px" : "800px"}
          height={matches_1800 ? "1080px" : matches_1280 ? "720px" : "480px"}
          className={classes.iframe}
          allowFullScreen
        /> */}
        <iframe
          title="清官式大木作虚拟搭建实验"
          src={virtualUrl}
          scrolling="no"
          allowFullScreen
          className={classes.iframe}
        ></iframe>
      </div>
    </>
  );
}

export default VirtualPage;
